export type CrmPageScope = 'self' | 'all';

export const resolveCrmPageScopeFromPathname = (
  pathname?: string | null,
): CrmPageScope => {
  const normalized = String(pathname || '').trim();
  if (!normalized) {
    return 'self';
  }
  if (
    normalized.includes('/customer/all') ||
    normalized.includes('/customer/pool') ||
    normalized.includes('/lead/all') ||
    normalized.includes('/lead/pool') ||
    normalized.includes('/opportunity/all') ||
    normalized.includes('/opportunity/pool') ||
    normalized.includes('/contract/all') ||
    normalized.includes('/quote/all')
  ) {
    return 'all';
  }
  return 'self';
};
